import { WIX_PORTFOLIO } from '@wix/app-definition-ids';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { updatePortfolioCollectionsAltText } from '../../../api/new-infra-updates/update-portfolio-collections-alt-text';
import { altTextScreenPageIdAtom } from '../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../hooks/rules-state';
import { useNavigation } from '../../../hooks/use-navigation';
import { useImageElementsOrder } from '../alt-text/use-image-elements-order';
export const usePortfolioCollectionsAltTextHandlers = () => {
  const {
    getPagesData
  } = usePanelStateAtom();
  const pageIdToPageData = getPagesData();
  const {
    getOrderedImageElements
  } = useImageElementsOrder();
  const altTextScreenPageId = useAtomValue(altTextScreenPageIdAtom);
  assertNotOptional(altTextScreenPageId);
  const {
    pageId
  } = altTextScreenPageId;
  const errorHandler = useErrorHandler();
  const httpClient = useHttpClient();
  const navigateToPage = useNavigation();
  const innerRoutes = useMemo(() => {
    var _pageIdToPageData$get;
    return (_pageIdToPageData$get = pageIdToPageData.get(pageId)) == null ? void 0 : _pageIdToPageData$get.innerRoutes;
  }, [pageIdToPageData, pageId]);
  const openImageElement = useCallback(nextElement => {
    navigateToPage(pageId, nextElement.entityId);
  }, [navigateToPage, pageId]);
  const getEntityName = useCallback(entityId => {
    var _innerRoutes$find;
    return (innerRoutes == null || (_innerRoutes$find = innerRoutes.find(innerRoute => innerRoute.id === entityId)) == null ? void 0 : _innerRoutes$find.name) ?? '';
  }, [innerRoutes]);
  const getElementOrder = useCallback(altImageRuleProps => getOrderedImageElements(altImageRuleProps), [getOrderedImageElements]);
  const enabledDecorativeImages = false;
  const appDefinitionId = WIX_PORTFOLIO;
  const setBulkAltText = useCallback(async bulkAltTextData => {
    const response = await updatePortfolioCollectionsAltText(httpClient, errorHandler, bulkAltTextData);
    if (response.success === false) {
      throw new Error(response.errorMessage);
    }
  }, [errorHandler, httpClient]);
  return useMemo(() => ({
    appDefinitionId,
    enabledDecorativeImages,
    getElementOrder,
    getEntityName,
    openImageElement,
    setBulkAltText
  }), [appDefinitionId, getElementOrder, enabledDecorativeImages, getEntityName, openImageElement, setBulkAltText]);
};
//# sourceMappingURL=use-portfolio-collections-alt-text-rule-handlers.js.map